/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Tooltip } from '@mui/material';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { BoulderIcon } from 'src/common/ui/components';

export const FyiIcon = ({ fyi }: { fyi?: string | null }) =>
  fyi ? (
    <Tooltip title={fyi}>
      <span
        css={css`
          display: block;
          color: ${Colors.CoolGray7};
          width: 20px;
          height: 20px;

          svg {
            display: block;
          }

          &:hover {
            color: ${Colors.BlueSpruce};
          }
        `}
      >
        <BoulderIcon icon="feedback" size={20} />
      </span>
    </Tooltip>
  ) : null;
